module.exports = __webpack_public_path__ + "img/treatment-history-section-en.252c696c.jpg";